import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { SvgIconProps } from '@mui/material';

/**
 * The arrow of a select filter in a table header. MUI lets a click fall through its select arrow
 * to the field underneath, but the filter's clear button pushes the arrow past the end of the
 * field, so nothing is underneath and the click did nothing. This arrow hands its click to the
 * field instead.
 */
export function TableFilterSelectIcon(props: SvgIconProps) {
    return (
        <ArrowDropDownIcon
            {...props}
            style={{ ...props.style, pointerEvents: 'auto', cursor: 'pointer' }}
            onMouseDown={(event) => {
                event.preventDefault();
                event.currentTarget.parentElement?.querySelector('.MuiSelect-select')
                    ?.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, button: 0 }));
            }}
        />
    );
}
